// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 125 ? "0119c7e0" : chunkId) + "." + {"23":"1f16945d25f76fa3","125":"201943ea9673f107","1102":"66126e784bb7f430","1873":"cda413e7d41e5b68"}[chunkId] + ".js";
};